// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/ScenarioHeader/ScenarioHeader.css */

.scenario-header-container {
  position: relative;
  margin: 8px;
  z-index: 100;
}

.scenario-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  background: linear-gradient(135deg, #2C3E50 0%, #34495E 100%);
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
  cursor: pointer;
}

/* Left section: Name and primary person */
.header-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
  min-width: 100px;
}

.scenario-name {
  margin: 0;
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 3px 6px;
  border-radius: 4px;
  transition: background-color 0.2s;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
}

.scenario-name:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.scenario-name-input {
  font-size: 14px;
  font-weight: 600;
  padding: 3px 6px;
  border: 2px solid #3498DB;
  border-radius: 4px;
  background-color: white;
  color: #2C3E50;
  width: 120px;
}

.scenario-name-input:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.3);
}

/* Primary person badge */
.primary-person-badge {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 3px 6px;
  background: rgba(245, 158, 11, 0.2);
  border: 1px solid rgba(245, 158, 11, 0.5);
  border-radius: 10px;
  font-size: 10px;
  color: #FCD34D;
}

.primary-person-badge .star {
  font-size: 9px;
}

.primary-person-badge .name {
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Center section: Capital → Dates → DansMaPoche → Enregistrer */
.header-center {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 1 auto;
  justify-content: center;
}

.header-field {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.header-field label {
  font-size: 9px;
  color: rgba(255, 255, 255, 0.7);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.header-field input[type="date"],
.header-field input[type="number"] {
  padding: 4px 6px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  font-size: 11px;
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
}

.header-field input[type="date"] {
  width: 115px;
}

.header-field input[type="number"] {
  width: 70px;
}

.header-field input:focus {
  outline: none;
  border-color: #3498DB;
  background-color: rgba(255, 255, 255, 0.15);
}

.header-field input[type="date"]::-webkit-calendar-picker-indicator {
  filter: invert(1);
  cursor: pointer;
}

/* DansMaPoche result box */
.dans-ma-poche {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4px 10px;
  background: linear-gradient(135deg, #27AE60 0%, #2ECC71 100%);
  border-radius: 4px;
  min-width: 100px;
}

.dans-ma-poche-label {
  font-size: 8px;
  color: rgba(255, 255, 255, 0.9);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.dans-ma-poche-value {
  font-size: 13px;
  font-weight: 700;
  color: white;
  font-family: 'Monaco', 'Menlo', monospace;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.dans-ma-poche.calculating {
  opacity: 0.7;
}

.dans-ma-poche.calculating .dans-ma-poche-value {
  animation: pulse 1s infinite;
}

.dans-ma-poche.missing-dates {
  background: linear-gradient(135deg, #95a5a6 0%, #bdc3c7 100%);
}

.dans-ma-poche.missing-dates .dans-ma-poche-value {
  font-size: 11px;
  opacity: 0.9;
}

.missing-dates-hint {
  font-size: 7px;
  color: rgba(255, 255, 255, 0.8);
  margin-top: 1px;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

/* Right section: Fold arrow + Niveau (alone) */
.header-right {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 0 0 auto;
}

/* Expand button */
.expand-btn {
  width: 26px;
  height: 26px;
  padding: 0;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 10px;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.expand-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

/* Add Level button */
.add-level-btn {
  padding: 6px 10px;
  background-color: #3498DB;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.add-level-btn:hover:not(:disabled) {
  background-color: #2980B9;
}

.add-level-btn:disabled {
  background-color: #7F8C8D;
  cursor: not-allowed;
  opacity: 0.7;
}

/* Expanded section - OVERLAY (position absolute) */
.scenario-header-expanded {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border-radius: 0 0 6px 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 12px;
  z-index: 200;
  animation: slideDown 0.2s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Description and Notes fields */
.expanded-fields {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #ECF0F1;
}

.field-group {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.field-group label {
  font-size: 10px;
  color: #7F8C8D;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.field-group input[type="text"],
.field-group textarea {
  padding: 8px 10px;
  border: 1px solid #BDC3C7;
  border-radius: 4px;
  font-size: 12px;
  color: #2C3E50;
  resize: none;
}

.field-group input[type="text"]:focus,
.field-group textarea:focus {
  outline: none;
  border-color: #3498DB;
  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
}

.field-group textarea {
  min-height: 50px;
}

/* Breakdown - compact horizontal */
.expanded-breakdown {
  display: flex;
  gap: 16px;
}

.breakdown-section {
  flex: 1 1;
  background: #F8F9FA;
  border-radius: 4px;
  padding: 8px 10px;
}

.breakdown-section h4 {
  margin: 0 0 6px 0;
  font-size: 10px;
  color: #7F8C8D;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.breakdown-items {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  font-size: 11px;
  color: #2C3E50;
}

.breakdown-items .item {
  padding: 2px 6px;
  background: white;
  border-radius: 3px;
  white-space: nowrap;
}

.breakdown-items .item.total {
  font-weight: 600;
  background: #ECF0F1;
}

.breakdown-items .item.negative {
  color: #E74C3C;
}

.no-data {
  color: #BDC3C7;
  font-size: 11px;
}

/* Result section */
.breakdown-section.result {
  background: linear-gradient(135deg, #27AE60 0%, #2ECC71 100%);
  text-align: center;
}

.breakdown-section.result h4 {
  color: rgba(255, 255, 255, 0.8);
}

.breakdown-section.result .result-value {
  font-size: 18px;
  font-weight: 700;
  color: white;
  font-family: 'Monaco', 'Menlo', monospace;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.breakdown-section.result .rate {
  display: block;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.9);
  margin-top: 4px;
}

.breakdown-section.result .capital-note {
  display: block;
  font-size: 9px;
  color: rgba(255, 255, 255, 0.7);
  margin-top: 2px;
}

/* Responsive */
@media (max-width: 900px) {
  .scenario-header {
    flex-wrap: wrap;
    gap: 8px;
  }

  .header-center {
    order: 10;
    flex: 1 0 100%;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .expanded-breakdown {
    flex-direction: column;
  }
}

@media (max-width: 600px) {
  .header-left {
    flex: 1 0 100%;
  }

  .expanded-fields {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ScenarioHeader/ScenarioHeader.css"],"names":[],"mappings":"AAAA,qDAAqD;;AAErD;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,6DAA6D;EAC7D,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;AACjB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,6DAA6D;EAC7D,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,0BAA0B;EAC1B,0CAA0C;EAC1C,aAAa;EACb,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,+BAA+B;EAC/B,eAAe;AACjB;;AAEA,eAAe;AACf;EACE;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,SAAS;IACT,cAAc;IACd,2BAA2B;IAC3B,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["/* src/components/ScenarioHeader/ScenarioHeader.css */\n\n.scenario-header-container {\n  position: relative;\n  margin: 8px;\n  z-index: 100;\n}\n\n.scenario-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 12px;\n  background: linear-gradient(135deg, #2C3E50 0%, #34495E 100%);\n  border-radius: 6px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);\n  cursor: pointer;\n}\n\n/* Left section: Name and primary person */\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 0 0 auto;\n  min-width: 100px;\n}\n\n.scenario-name {\n  margin: 0;\n  color: white;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 3px 6px;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 150px;\n}\n\n.scenario-name:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.scenario-name-input {\n  font-size: 14px;\n  font-weight: 600;\n  padding: 3px 6px;\n  border: 2px solid #3498DB;\n  border-radius: 4px;\n  background-color: white;\n  color: #2C3E50;\n  width: 120px;\n}\n\n.scenario-name-input:focus {\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.3);\n}\n\n/* Primary person badge */\n.primary-person-badge {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 6px;\n  background: rgba(245, 158, 11, 0.2);\n  border: 1px solid rgba(245, 158, 11, 0.5);\n  border-radius: 10px;\n  font-size: 10px;\n  color: #FCD34D;\n}\n\n.primary-person-badge .star {\n  font-size: 9px;\n}\n\n.primary-person-badge .name {\n  max-width: 80px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Center section: Capital → Dates → DansMaPoche → Enregistrer */\n.header-center {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex: 1 1 auto;\n  justify-content: center;\n}\n\n.header-field {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.header-field label {\n  font-size: 9px;\n  color: rgba(255, 255, 255, 0.7);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.header-field input[type=\"date\"],\n.header-field input[type=\"number\"] {\n  padding: 4px 6px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 4px;\n  font-size: 11px;\n  background-color: rgba(255, 255, 255, 0.1);\n  color: white;\n}\n\n.header-field input[type=\"date\"] {\n  width: 115px;\n}\n\n.header-field input[type=\"number\"] {\n  width: 70px;\n}\n\n.header-field input:focus {\n  outline: none;\n  border-color: #3498DB;\n  background-color: rgba(255, 255, 255, 0.15);\n}\n\n.header-field input[type=\"date\"]::-webkit-calendar-picker-indicator {\n  filter: invert(1);\n  cursor: pointer;\n}\n\n/* DansMaPoche result box */\n.dans-ma-poche {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 4px 10px;\n  background: linear-gradient(135deg, #27AE60 0%, #2ECC71 100%);\n  border-radius: 4px;\n  min-width: 100px;\n}\n\n.dans-ma-poche-label {\n  font-size: 8px;\n  color: rgba(255, 255, 255, 0.9);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.dans-ma-poche-value {\n  font-size: 13px;\n  font-weight: 700;\n  color: white;\n  font-family: 'Monaco', 'Menlo', monospace;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n.dans-ma-poche.calculating {\n  opacity: 0.7;\n}\n\n.dans-ma-poche.calculating .dans-ma-poche-value {\n  animation: pulse 1s infinite;\n}\n\n.dans-ma-poche.missing-dates {\n  background: linear-gradient(135deg, #95a5a6 0%, #bdc3c7 100%);\n}\n\n.dans-ma-poche.missing-dates .dans-ma-poche-value {\n  font-size: 11px;\n  opacity: 0.9;\n}\n\n.missing-dates-hint {\n  font-size: 7px;\n  color: rgba(255, 255, 255, 0.8);\n  margin-top: 1px;\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.5; }\n}\n\n/* Right section: Fold arrow + Niveau (alone) */\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex: 0 0 auto;\n}\n\n/* Expand button */\n.expand-btn {\n  width: 26px;\n  height: 26px;\n  padding: 0;\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 10px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.expand-btn:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n/* Add Level button */\n.add-level-btn {\n  padding: 6px 10px;\n  background-color: #3498DB;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.add-level-btn:hover:not(:disabled) {\n  background-color: #2980B9;\n}\n\n.add-level-btn:disabled {\n  background-color: #7F8C8D;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n/* Expanded section - OVERLAY (position absolute) */\n.scenario-header-expanded {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: white;\n  border-radius: 0 0 6px 6px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  padding: 12px;\n  z-index: 200;\n  animation: slideDown 0.2s ease-out;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Description and Notes fields */\n.expanded-fields {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 12px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #ECF0F1;\n}\n\n.field-group {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.field-group label {\n  font-size: 10px;\n  color: #7F8C8D;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.field-group input[type=\"text\"],\n.field-group textarea {\n  padding: 8px 10px;\n  border: 1px solid #BDC3C7;\n  border-radius: 4px;\n  font-size: 12px;\n  color: #2C3E50;\n  resize: none;\n}\n\n.field-group input[type=\"text\"]:focus,\n.field-group textarea:focus {\n  outline: none;\n  border-color: #3498DB;\n  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);\n}\n\n.field-group textarea {\n  min-height: 50px;\n}\n\n/* Breakdown - compact horizontal */\n.expanded-breakdown {\n  display: flex;\n  gap: 16px;\n}\n\n.breakdown-section {\n  flex: 1;\n  background: #F8F9FA;\n  border-radius: 4px;\n  padding: 8px 10px;\n}\n\n.breakdown-section h4 {\n  margin: 0 0 6px 0;\n  font-size: 10px;\n  color: #7F8C8D;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.breakdown-items {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  font-size: 11px;\n  color: #2C3E50;\n}\n\n.breakdown-items .item {\n  padding: 2px 6px;\n  background: white;\n  border-radius: 3px;\n  white-space: nowrap;\n}\n\n.breakdown-items .item.total {\n  font-weight: 600;\n  background: #ECF0F1;\n}\n\n.breakdown-items .item.negative {\n  color: #E74C3C;\n}\n\n.no-data {\n  color: #BDC3C7;\n  font-size: 11px;\n}\n\n/* Result section */\n.breakdown-section.result {\n  background: linear-gradient(135deg, #27AE60 0%, #2ECC71 100%);\n  text-align: center;\n}\n\n.breakdown-section.result h4 {\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.breakdown-section.result .result-value {\n  font-size: 18px;\n  font-weight: 700;\n  color: white;\n  font-family: 'Monaco', 'Menlo', monospace;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n.breakdown-section.result .rate {\n  display: block;\n  font-size: 10px;\n  color: rgba(255, 255, 255, 0.9);\n  margin-top: 4px;\n}\n\n.breakdown-section.result .capital-note {\n  display: block;\n  font-size: 9px;\n  color: rgba(255, 255, 255, 0.7);\n  margin-top: 2px;\n}\n\n/* Responsive */\n@media (max-width: 900px) {\n  .scenario-header {\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .header-center {\n    order: 10;\n    flex: 1 0 100%;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n  }\n\n  .expanded-breakdown {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 600px) {\n  .header-left {\n    flex: 1 0 100%;\n  }\n\n  .expanded-fields {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
